<nav class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
  <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
    <!-- kenny modified -->
    <a class="navbar-brand brand-logo" routerLink="/dashboard">
      <img src="assets/images/logo.png" alt="logo" /> </a>
    <a class="navbar-brand brand-logo-mini" routerLink="/dashboard">
      <img src="assets/images/logo-mini.svg" alt="logo" /> </a>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center">
    <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize"
      (click)="toggleIconOnlySidebar()">
      <span class="mdi mdi-menu"></span>
    </button>
    <ul class="navbar-nav">
      <li class="nav-item font-weight-semibold d-none d-lg-flex">Help : +254 727 998887</li>
      <li class="nav-item dropdown language-dropdown" ngbDropdown>
        <a class="nav-link px-2 d-flex align-items-center" id="LanguageDropdown" ngbDropdownToggle>
          <div class="d-inline-flex mr-0 mr-md-3">
            <div class="flag-icon-holder">
              <i class="flag-icon flag-icon-us"></i>
            </div>
          </div>
          <span class="profile-text font-weight-medium d-none d-md-block">English</span>
        </a>
        <div class="dropdown-menu dropdown-menu-left navbar-dropdown py-2" ngbDropdownMenu
          aria-labelledby="LanguageDropdown">
          <a class="dropdown-item">
            <div class="flag-icon-holder">
              <i class="flag-icon flag-icon-us"></i>
            </div>English
          </a>
          <!-- kenny modified -->
          <!-- <a class="dropdown-item">
            <div class="flag-icon-holder">
              <i class="flag-icon flag-icon-fr"></i>
            </div>French
          </a>
          <a class="dropdown-item">
            <div class="flag-icon-holder">
              <i class="flag-icon flag-icon-ae"></i>
            </div>Arabic
          </a>
          <a class="dropdown-item">
            <div class="flag-icon-holder">
              <i class="flag-icon flag-icon-ru"></i>
            </div>Russian
          </a> -->
        </div>
      </li>
    </ul>
    <form class="ml-auto search-form d-none d-md-block" action="#">
      <div class="form-group">
        <input type="search" class="form-control" placeholder="Search Here">
      </div>
    </form>
    <ul class="navbar-nav navbar-nav-right">
      <li class="nav-item dropdown" ngbDropdown>
        <!-- kenny modified -->
        <!-- <a class="nav-link count-indicator dropdown-toggle" id="messageDropdown" ngbDropdownToggle>
          <i class="mdi mdi-file-outline"></i>
          <span class="count">7</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list pb-0" ngbDropdownMenu
          aria-labelledby="messageDropdown">
          <a class="dropdown-item py-3">
            <p class="mb-0 font-weight-medium float-left">You have 7 unread mails </p>
            <span class="badge badge-pill badge-primary float-right">View all</span>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="assets/images/faces/face10.jpg" alt="image" class="img-sm profile-pic"> </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">Marian Garner </p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </a>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="assets/images/faces/face12.jpg" alt="image" class="img-sm profile-pic"> </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">David Grey </p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </a>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="assets/images/faces/face1.jpg" alt="image" class="img-sm profile-pic"> </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">Travis Jenkins </p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </a>
        </div> -->
      </li>
      <li class="nav-item dropdown ml-4" ngbDropdown>
        <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" ngbDropdownToggle>
          <i class="mdi mdi-bell-outline"></i>
          <span class="count bg-success">4</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list pb-0" ngbDropdownMenu
          aria-labelledby="UserDropdown">
          <a class="dropdown-item py-3 border-bottom">
            <p class="mb-0 font-weight-medium float-left">You have 4 new notifications </p>
            <span class="badge badge-pill badge-primary float-right">View all</span>
          </a>
          <a class="dropdown-item preview-item py-3">
            <div class="preview-thumbnail">
              <i class="mdi mdi-alert m-auto text-primary"></i>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-normal text-dark mb-1">Application Error</h6>
              <p class="font-weight-light small-text mb-0"> Just now </p>
            </div>
          </a>
          <a class="dropdown-item preview-item py-3">
            <div class="preview-thumbnail">
              <i class="mdi mdi-settings m-auto text-primary"></i>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-normal text-dark mb-1">Settings</h6>
              <p class="font-weight-light small-text mb-0"> Private message </p>
            </div>
          </a>
          <a class="dropdown-item preview-item py-3">
            <div class="preview-thumbnail">
              <i class="mdi mdi-airballoon m-auto text-primary"></i>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-normal text-dark mb-1">New user registration</h6>
              <p class="font-weight-light small-text mb-0"> 2 days ago </p>
            </div>
          </a>
        </div>
      </li>
      <li class="nav-item dropdown d-none d-xl-inline-flex" ngbDropdown>
        <a class="nav-link dropdown-toggle" id="UserDropdown" ngbDropdownToggle>
          <img class="img-xs rounded-circle" src="assets/images/faces/face1.jpg" alt="Profile image">
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown" ngbDropdownMenu aria-labelledby="UserDropdown">
          <div class="dropdown-header text-center">
            <!-- kenny modified -->            
            <!-- <img class="img-md rounded-circle" src="assets/images/faces/face8.jpg" alt="Profile image"> -->
            <!-- kenny modified -->            
            <!-- <p class="mb-1 mt-3 font-weight-semibold">Allen Moreno</p>
            <p class="font-weight-light text-muted mb-0">allenmoreno@gmail.com</p> -->
            <p class="mb-1 mt-3 font-weight-semibold">Kennedy Kinyanjui</p>
            <p class="font-weight-light text-muted mb-0">kennedykinyanjui@outlook.com</p>
          </div>
          <a class="dropdown-item">My Profile <span class="badge badge-pill badge-danger">1</span><i
              class="dropdown-item-icon ti-dashboard"></i></a>
              <!-- kenny modified -->            
          <!-- <a class="dropdown-item">Messages<i class="dropdown-item-icon ti-comment-alt"></i></a> -->
          <!-- <a class="dropdown-item">Activity<i class="dropdown-item-icon ti-location-arrow"></i></a> -->
          <!-- <a class="dropdown-item">FAQ<i class="dropdown-item-icon ti-help-alt"></i></a> -->
          <a class="dropdown-item">Sign Out<i class="dropdown-item-icon ti-power-off"></i></a>
        </div>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center ml-auto pr-0" type="button"
      (click)="toggleRightSidebar()">
      <span class="mdi mdi-menu"></span>
    </button>
  </div>
</nav>
